import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import ReactDOM from "react-dom";

import {
  FiShield,
  FiX,
} from "react-icons/fi";

import API from "../../../../../../utils/apiCalling";

import {
  config,
} from "../../../../../../utils/apiUrl";

import {
  EMPLOYEE_STATUSES,
} from "../utils/employee.constants";

import {
  formatEmployeeLabel,
  getEmployeeApiError,
} from "../utils/employee.utils";

import "./EmployeeManagement.css";


const ChangeEmployeeStatus = ({
  open,

  employee,

  onClose,

  onSuccess,
}) => {

  const api =
    useMemo(
      () =>
        new API(),
      []
    );


  const [
    status,
    setStatus,
  ] =
    useState(
      "ACTIVE"
    );


  const [
    loading,
    setLoading,
  ] =
    useState(false);


  const [
    error,
    setError,
  ] =
    useState("");


  useEffect(
    () => {

      if (
        open
      ) {

        setStatus(
          employee?.status ||
          "ACTIVE"
        );


        setError(
          ""
        );

      }

    },
    [
      open,
      employee,
    ]
  );


  if (
    !open ||
    !employee
  ) {

    return null;

  }


  const handleSubmit =
    async (
      event
    ) => {

      event.preventDefault();


      try {

        setLoading(
          true
        );


        setError(
          ""
        );


        const response =
          await api.patch(
            config.changeEmployeeStatus(
              employee._id
            ),
            {
              status,
            }
          );


        if (
          response?.status !==
          "success"
        ) {

          throw new Error(
            response?.message ||
            "Unable to update status."
          );

        }


        await onSuccess?.(
          response?.data
        );

      } catch (
        requestError
      ) {

        setError(
          getEmployeeApiError(
            requestError,
            "Unable to update employee status."
          )
        );

      } finally {

        setLoading(
          false
        );

      }

    };


  return ReactDOM
    .createPortal(

      <div className="employee-status-modal-root">

        <button
          type="button"
          className="employee-status-modal-backdrop"
          onClick={
            loading
              ?
              undefined
              :
              onClose
          }
          aria-label="Close"
        />


        <form
          className="employee-status-modal"
          onSubmit={
            handleSubmit
          }
        >

          <header>

            <div>

              <span>
                <FiShield />
              </span>

              <div>

                <small>
                  EMPLOYEE STATUS
                </small>

                <h3>
                  Change Status
                </h3>

              </div>

            </div>


            <button
              type="button"
              onClick={
                onClose
              }
            >
              <FiX />
            </button>

          </header>


          <div className="employee-status-modal-body">

            <div className="employee-status-employee">

              <strong>
                {
                  employee.name
                }
              </strong>

              <span>
                {
                  employee.employeeCode
                }
              </span>

            </div>


            <label>
              Employment Status
            </label>


            <select
              value={
                status
              }
              onChange={
                (
                  event
                ) =>
                  setStatus(
                    event.target.value
                  )
              }
            >

              {
                EMPLOYEE_STATUSES.map(
                  (
                    value
                  ) => (

                    <option
                      key={value}
                      value={value}
                    >
                      {
                        formatEmployeeLabel(
                          value
                        )
                      }
                    </option>

                  )
                )
              }

            </select>


            {
              [
                "RESIGNED",
                "TERMINATED",
              ].includes(
                status
              )
                ?
                (
                  <div className="employee-status-warning">

                    Changing the employee to

                    {" "}

                    <strong>
                      {
                        formatEmployeeLabel(
                          status
                        )
                      }
                    </strong>

                    {" "}

                    will also disable their login access.

                  </div>
                )
                :
                null
            }


            {
              error
                ?
                (
                  <div className="employee-status-error">
                    {error}
                  </div>
                )
                :
                null
            }

          </div>


          <footer>

            <button
              type="button"
              onClick={
                onClose
              }
              disabled={
                loading
              }
            >
              Cancel
            </button>


            <button
              type="submit"
              disabled={
                loading
              }
            >

              {
                loading
                  ?
                  "Updating..."
                  :
                  "Update Status"
              }

            </button>

          </footer>

        </form>

      </div>,

      document.body

    );

};


export default ChangeEmployeeStatus;